export default __webpack_public_path__ + "static/media/1.9910345c.webp";